import { apiUrl, authHeaders } from './auth';

export const fetchSyncJobs = async () => {
    const resp = await fetch(apiUrl + '/v2/reports/syncloc', {
        headers: authHeaders(),
    });
    const json = await resp.json();
    return json;
};

export const fetchNxtSyncStatus = async () => {
    const resp = await fetch(apiUrl + '/v2/nxt-sync-status', {
        headers: authHeaders(),
    });
    const json = await resp.json();
    return json;
};

export interface NxtFundCacheLookup {
    lookup_id: string;
    fund_id: string | null;
    description: string | null;
    inactive: boolean | null;
}

export const lookupNxtFundByLookupId = async (
    lookupId: string
): Promise<NxtFundCacheLookup> => {
    const url =
        apiUrl + '/v2/nxt-fund-cache?lookup_id=' + encodeURIComponent(lookupId);
    const resp = await fetch(url, { headers: authHeaders() });
    if (resp.status === 404) {
        return {
            lookup_id: lookupId,
            fund_id: null,
            description: null,
            inactive: null,
        };
    }
    if (!resp.ok) {
        throw new Error('Failed to look up NXT fund cache');
    }
    return await resp.json();
};

export const runCampaignSync = async (syncMode, startDate, campaignId) => {
    const resp = await fetch(apiUrl + '/v2/reports/syncloc', {
        method: 'post',
        headers: authHeaders(),
        body: JSON.stringify({ syncMode, startDate, campaignId }),
    });
    const json = await resp.json();
    return json;
};
